// extracted by mini-css-extract-plugin
export default {"form":"WaitList_form__PHImj","input":"WaitList_input__TGqGz","inputError":"WaitList_inputError__kSJXU","btn":"WaitList_btn__TSbVT"};